import { render, staticRenderFns } from "./UnmanagedItem.vue?vue&type=template&id=62a743cc&scoped=true&"
import script from "./UnmanagedItem.vue?vue&type=script&lang=ts&"
export * from "./UnmanagedItem.vue?vue&type=script&lang=ts&"
import style0 from "./UnmanagedItem.vue?vue&type=style&index=0&id=62a743cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a743cc",
  null
  
)

export default component.exports